export const LanguagesInManchester = [
  {
    heading: "Spanish",
    detail:
      "About 150-200 languages are spoken by Manchester residents, Spanish being a popular language in this area. Spanish translation services could help broaden your horizons to the Spanish-speaking demographic in Manchester, and beyond.",
    link: "/spanish-translation.php",
  },
  {
    heading: "Polish",
    detail:
      "Polish is another popular language in Manchester, accounting for being spoken by 9% of the population. Polish is also spoken by 45 million native speakers. At Tomedes, our polish-translators are all native-language speakers ",
    link: "/polish-translation.php",
  },
  {
    heading: "Romanian",
    detail:
      "Tomedes' Romanian translation services are equipped with translators that apply the know-how of their industries to your documents. Tomedes can accommodate all dialects of Romanian, expanding your business to international heights.",
    link: "/romanian-translation.php",
  },
  {
    heading: "Czech",
    detail:
      "A major language in Manchester, Czech is spoken by 14 million people in the world. We can help you reach the Czech demographic as well as the international Czech community with language services.",
    link: "/czech-translation.php",
  },
  {
    heading: "Urdu",
    detail:
      "Urdu is spoken by 70 million people worldwide. Did you know that at Tomedes, our Urdu translators apply their knowledge of Urdu and its dialects with their knowledge of your business niche in order to arrive at the perfect combination of translation?",
    link: "/urdu-translation.php",
  },
  {
    heading: "Bengali",
    detail:
      "Bengali is spoken by 230 million people globally, and at Tomedes, our Bengali translation services make sure your company or you are understood by this demographic, no matter what industry you're in.",
    link: "/bengali-translation.php",
  },
];
